var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E6F3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 13C19.4772 13 15 17.4772 15 23C15 28.5228 19.4772 33 25 33C30.5228 33 35 28.5228 35 23C35 17.4772 30.5228 13 25 13ZM13 23C13 16.3726 18.3726 11 25 11C31.6274 11 37 16.3726 37 23C37 29.6274 31.6274 35 25 35C18.3726 35 13 29.6274 13 23Z",
    fill: "#127050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19C22.7909 19 21 20.7909 21 23C21 25.2091 22.7909 27 25 27C27.2091 27 29 25.2091 29 23C29 20.7909 27.2091 19 25 19ZM19 23C19 19.6863 21.6863 17 25 17C28.3137 17 31 19.6863 31 23C31 26.3137 28.3137 29 25 29C21.6863 29 19 26.3137 19 23Z",
    fill: "#127050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 23C23 21.8954 23.8954 21 25 21C26.1046 21 27 21.8954 27 23C27 24.1046 26.1046 25 25 25C23.8954 25 23 24.1046 23 23Z",
    fill: "#127050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0375 31.6241C20.4107 32.0312 20.3832 32.6638 19.976 33.037L17.5787 35.2345C16.8321 35.9306 17.3312 36.9998 18.2003 36.9998L31.9003 36.9998C32.8036 36.9998 33.2206 35.8343 32.5495 35.2591C32.5411 35.2518 32.5328 35.2445 32.5246 35.237L30.1246 33.037C29.7175 32.6638 29.69 32.0312 30.0632 31.6241C30.4364 31.217 31.0689 31.1895 31.476 31.5627L33.8648 33.7524C35.974 35.5801 34.5912 38.9998 31.9003 38.9998L18.2003 38.9998C15.4702 38.9998 14.1695 35.6709 16.2199 33.767L16.2246 33.7626L16.2246 33.7627L18.6246 31.5627C19.0317 31.1895 19.6643 31.217 20.0375 31.6241Z",
    fill: "#127050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCamera);
export default __webpack_public_path__ + "static/media/modal-camera.adaaf90f6cdd0a63213cc75ff3dea823.svg";
export { ForwardRef as ReactComponent };